import React from "react";

// core components
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Table from "../../views/Table/Table.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";

import axios from "axios";
import style from "./styles.module.css";
import Button from "@material-ui/core/Button";
import ConfParts from "./confParts/ConfParts";
import IconButton from "@material-ui/core/IconButton";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import DeleteRoundedIcon from "@material-ui/icons/DeleteRounded";
import InputRoundedIcon from "@material-ui/icons/InputRounded";
import Snackbar from "../utils/snackbar/Snackbar";
import { withRouter } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import TopBar from "../utils/Topbar/TopBar.js";
import { connect } from "react-redux";
import { getParts } from "../../containers/app/actions";
import SplitButton from "../utils/SplitButton/SplitButton.js";
import PrintBarcode from "./barcodePrint/BarCode";
import ConfirmAlert from "../utils/ConfirmAlert/ConfirmAlert.js";

const Parts = (props) => {
  const [data, setData] = React.useState(false);
  const [filteredData, setFilteredData] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");

  const [alert, setAlert] = React.useState(false);
  const [addModal, setAddModal] = React.useState(false);
  const [editModal, setEditModal] = React.useState(false);
  const [activePart, setActivePart] = React.useState(false);

  React.useEffect(() => {
    props.getParts(props.user._id);
  }, []);

  React.useEffect(() => {
    // console.log("parts");
    // console.log(props.parts);
    if (props.parts) {
      let arr = [];
      arr = props.parts.filter((val) => {
        if (
          val.partName.toLowerCase().includes(searchValue.toLowerCase()) ||
          val.status.toLowerCase().includes(searchValue.toLowerCase())
        ) {
          return val;
        }
      });
      setFilteredData(arr);
    } else {
      setFilteredData(false);
    }
  }, [searchValue, props.parts]);

  const handleDelete = (value) => {
    axios({
      method: "post",
      url: "/deleteProductPart",
      data: {
        partId: value._id,
      },
    })
      .then((res) => {
        setAlert("Deleted Successfully");
        props.getParts(props.user._id);
      })
      .catch((err) => {
        setAlert("Something went wrong");
      });
  };

  const isLoading = !filteredData;
  const showData = !isLoading;
  const details = [];

  !isLoading &&
    filteredData.forEach((val, index) => {
      details.push([
        index + 1,
        val.partName,
        val.parts_barcode,
        val.height,
        val.width,
        val.length,
        val.weight,
        val.status,

        <React.Fragment>
          <PrintBarcode part={val} setAlert={(msg) => setAlert(msg)} />
          <IconButton
            onClick={() => {
              setActivePart(val);
              setEditModal(true);
            }}
          >
            <EditRoundedIcon />
          </IconButton>

          <ConfirmAlert
            msg={`Are you sure you want delete ?`}
            onClickEvent={() => handleDelete(val)}
          >
            <IconButton>
              <DeleteRoundedIcon />
            </IconButton>
          </ConfirmAlert>
        </React.Fragment>,
      ]);
    });

  return (
    <GridContainer>
      {addModal && (
        <ConfParts
          type="ADD"
          open={addModal}
          onClose={() => setAddModal(false)}
          onDone={() => {
            setAddModal(false);
            props.getParts(props.user._id);
          }}
          setAlert={(msg) => setAlert(msg)}
        />
      )}
      {activePart && (
        <ConfParts
          type="EDIT"
          activePart={activePart}
          open={editModal}
          onClose={() => setEditModal(false)}
          onDone={() => {
            setEditModal(false);
            setActivePart(false);
            props.getParts(props.user._id);
          }}
          setAlert={(msg) => setAlert(msg)}
        />
      )}

      <Snackbar open={alert} handleClose={() => setAlert(false)} />

      <TopBar
        searchValue={searchValue}
        onSearchChange={(value) => setSearchValue(value)}
        nav={[
          {
            Name: "Products",
            onClick: () => props.history.push("/admin/product"),
          },
          { Name: "Parts", onClick: () => {} },
        ]}
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>All Parts</h4>

              <div className={style.buttons}>
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={() => setAddModal(true)}
                >
                  Add Part
                </Button>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading && (
              <div className={style.loader}>
                <CircularProgress />
              </div>
            )}

            {showData && (
              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "Sl No",
                  "Part Name",
                  "Part Barcode",
                  "Height",
                  "Width",
                  "Length",
                  "Weight",
                  "Status",
                  "Action",
                ]}
                tableData={details}
              />
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

const mapStateToProps = (state) => ({
  user: state.appReducer.user,
  parts: state.appReducer.parts,
});
export default withRouter(connect(mapStateToProps, { getParts })(Parts));
